<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <div class="main-box">
                    <div class="header margin-b">
                        <div>Manager</div>
                    </div>
                    <div class="main-body ">
                        <div class="card-box margin-b">
                            <div class="card margin-b">

                                <div class="card-body  border-r">
                                    <div class="box">

                                        <div class="image-box">
                                            <div class="image-wrapper">
                                                <img src="assets/church_image.jpg">
                                            </div>
                                        </div>


                                        <div class="text-detail">
                                            <h5 class="card-title">Special title treatment</h5>
                                            <p class="card-text">With supporting text below as a natural lead-in to
                                                additional
                                                content.</p>
                                        </div>
                                    </div>
                                </div>

                            </div>


                            <div class="footer">
                                <div>

                                    <button type="button" class="btn btn-update btn-textcolor"><span><i
                                                class="fas fa-edit margin-r "></i></span>Update</button>
                                    <button type="button" class="btn btn-delete margin-l btn-textcolor"><span><i
                                                class="fas fa-trash-alt margin-r"></i></span>Delete</button>
                                </div>

                            </div>
                        </div>
                        <div class="card-box margin-b">
                            <div class="card margin-b">

                                <div class="card-body border-r">
                                    <div class="box">

                                        <div class="image-box">
                                            <div class="image-wrapper">
                                                <img src="assets/church_image.jpg">
                                            </div>
                                        </div>


                                        <div class="text-detail">
                                            <h5 class="card-title">Special title treatment</h5>
                                            <p class="card-text">With supporting text below as a natural lead-in to
                                                additional
                                                content.</p>
                                        </div>
                                    </div>
                                </div>

                            </div>


                            <div class="footer">
                                <div>

                                    <button type="button" class="btn btn-update btn-textcolor"><span><i
                                                class="fas fa-edit margin-r "></i></span>Update</button>
                                    <button type="button" class="btn btn-delete margin-l btn-textcolor"><span><i
                                                class="fas fa-trash-alt margin-r"></i></span>Delete</button>
                                </div>

                            </div>
                        </div>
                        <div class="card-box margin-b">
                            <div class="card margin-b">

                                <div class="card-body border-r ">


                                    <div class="box">

                                        <div class="image-box">
                                            <div class="image-wrapper">
                                                <img src="assets/church_image.jpg">
                                            </div>
                                        </div>


                                        <div class="text-detail">
                                            <h5 class="card-title">Special title treatment</h5>
                                            <p class="card-text">With supporting text below as a natural lead-in to
                                                additional
                                                content.</p>
                                        </div>
                                    </div>


                               
                                </div>

                            </div>


                            <div class="footer">
                                <div>

                                    <button type="button" class="btn btn-update btn-textcolor"><span><i
                                                class="fas fa-edit margin-r "></i></span>Update</button>
                                    <button type="button" class="btn btn-delete margin-l btn-textcolor"><span><i
                                                class="fas fa-trash-alt margin-r"></i></span>Delete</button>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>


            </div>
            <div class="col-md-3">
                <app-events [showheader]=true ></app-events>
            </div>
        </div>
    </div>
</div>